module.exports = __webpack_public_path__ + "static/media/logo.279138df.png";